import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {}

const StarSolidIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="23"
			height="22"
			viewBox="0 0 23 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M22.5016 12.6193C21.584 11.8062 17.3659 8.40944 17.1673 7.65651L18.1448 0L11.071 3.70277L3.76967 0.342086L5.34125 8.09142L0 14.0908L7.84921 15.3233L11.9801 22L15.0718 14.9606L22.9398 13.4049C23.1573 12.5987 22.7327 12.8256 22.5016 12.6193ZM11.9801 14.4363C10.4907 12.7586 10.3538 11.1238 7.53424 11.6859C7.50172 10.5152 9.13486 10.1783 9.24784 9.10048C9.34371 8.19284 8.54086 7.421 8.5614 6.53227C10.9786 7.76481 11.7455 7.63588 14.0344 6.18675C13.0107 8.85982 14.1525 9.55087 15.7497 11.3404C13.3359 11.1564 12.2951 12.0813 11.9801 14.4363Z"
				fill="currentColor"
				fillOpacity="0.5"
			/>
		</svg>
	);
};

export default memo(StarSolidIcon);
